import React from 'react';

const CrownIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <path
      d='M9 20 7 9l5.5 5L16 8l3.5 6L25 9l-2 11H9m14 3c0 .6-.4 1-1 1H10c-.6 0-1-.4-1-1v-1h14v1z'
      fill='currentColor'
      fillRule='nonzero'
    />
  </svg>
);

export default CrownIcon;
